import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { ApiAuthorizationModule } from 'src/api-authorization/api-authorization.module';
import { AuthorizeInterceptor } from 'src/api-authorization/authorize.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { TokenComponent } from './token/token.component';
import { MaterialModule } from './shared/material.module';
import { SharedModule } from './shared/shared.module';
import { SignupComponent } from './home/components/signup/signup.component';
import { ProfileFormComponent } from './home/components/profile-form/profile-form.component';
import { PasswordFormComponent } from './home/components/password-form/password-form.component';
import { ReleaseNotesComponent } from './release-notes/release-notes.component';
import { AnalyticsInterceptor } from './shared/analytics/analytics.interceptor';

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    TokenComponent,
    SignupComponent,
    ProfileFormComponent,
    PasswordFormComponent,
    ReleaseNotesComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ApiAuthorizationModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    SharedModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizeInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AnalyticsInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
